function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Invoice_Incoming",
  "data-name": "Invoice Incoming",
  transform: "translate(-1092.802 -283.6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_invoice_2800686",
  transform: "translate(1101 284)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M10.356,18.529a3.283,3.283,0,0,1-3.089-2.12L6.177,17.5a.3.3,0,0,1-.433,0L4.55,16.306,3.356,17.5a.3.3,0,0,1-.433,0L1.73,16.306.536,17.5a.421.421,0,0,1-.227.083.258.258,0,0,1-.123-.021A.322.322,0,0,1,0,17.274V.309A.317.317,0,0,1,.309,0H8.668a.026.026,0,0,1,.021.011.026.026,0,0,0,.02.01.027.027,0,0,1,.021.01.027.027,0,0,0,.021.01.027.027,0,0,1,.021.01.027.027,0,0,0,.021.01.073.073,0,0,1,.041.021l3.046,3.026a.027.027,0,0,0,.01.021.027.027,0,0,1,.01.021.027.027,0,0,0,.01.021.027.027,0,0,1,.01.021c.021.02.021.021.021.041.021.02.021.02.021.04v9.079a3.207,3.207,0,0,1,1.688,2.883A3.3,3.3,0,0,1,10.356,18.529Zm.02-5.971a2.677,2.677,0,1,0,2.677,2.677A2.679,2.679,0,0,0,10.376,12.559Zm-5.816,3a.3.3,0,0,1,.216.093l1.215,1.193,1.132-1.132-.006-.045a3.349,3.349,0,0,1-.036-.449,3.3,3.3,0,0,1,3.294-3.294,3,3,0,0,1,.968.144v-8.4H8.606A.317.317,0,0,1,8.3,3.356V.617H.617V16.532l.886-.885a.3.3,0,0,1,.432,0L3.15,16.841l1.194-1.193A.3.3,0,0,1,4.56,15.554ZM8.915,1.071V3.047h1.976Z",
  transform: "translate(0.165)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M2.954.1,1.307,1.742.525.96a.3.3,0,0,0-.432,0,.3.3,0,0,0,0,.432l.988.988a.31.31,0,0,0,.226.082.31.31,0,0,0,.226-.082L3.407.507a.3.3,0,0,0,0-.432A.345.345,0,0,0,2.954.1Z",
  transform: "translate(8.884 13.987)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 1.853,
  height: 0.618,
  transform: "translate(8.379 10.418)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  width: 1.853,
  height: 0.618,
  transform: "translate(8.379 8.585)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M1.174,3.15h.782a.515.515,0,0,1,0,1.029H.556a.35.35,0,1,0,0,.7h.679V5.25a.347.347,0,0,0,.35.35.361.361,0,0,0,.35-.35V4.879h.021A1.2,1.2,0,0,0,3.15,3.665,1.213,1.213,0,0,0,1.956,2.45H1.215a.515.515,0,0,1,0-1.029H2.553a.361.361,0,0,0,.35-.35.347.347,0,0,0-.35-.35H1.915V.35A.347.347,0,0,0,1.565,0a.361.361,0,0,0-.35.35V.721H1.194A1.2,1.2,0,0,0,0,1.935,1.209,1.209,0,0,0,1.174,3.15Z",
  transform: "translate(2.079 7.812)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  "data-name": "Rectangle",
  width: 4.241,
  height: 0.618,
  transform: "translate(2.039 1.585)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  "data-name": "Rectangle",
  width: 4.241,
  height: 0.618,
  transform: "translate(2.039 5.25)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  "data-name": "Rectangle",
  width: 2.8,
  height: 0.618,
  transform: "translate(2.039 3.417)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M7.043,8.64a.486.486,0,0,1-.359.14.491.491,0,0,1-.5-.491l-.07-1.53H0V2.006H6.113L6.128.5a.5.5,0,0,1,.5-.5A.586.586,0,0,1,7,.155l4.982,3.82a.464.464,0,0,1,.141.343.485.485,0,0,1-.141.359L7.262,8.469Z",
  transform: "translate(1093.202 284)",
  fill: "#222",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.8
}));

var SvgInvoiceIncoming = function SvgInvoiceIncoming(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.013,
    height: 18.929,
    viewBox: "0 0 22.013 18.929",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoiceIncoming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoiceIncoming.b28908a9.svg";
export { ForwardRef as ReactComponent };